
import React from 'react';

import { t } from 'i18next';
import { useTranslation } from 'react-i18next';



function Home () {

  const { i18n } = useTranslation()

	const currentLanguageCode = i18n.language;

  const sectionStyle = currentLanguageCode === 'fr'? {  backgroundImage: `url("../assets/images/homeImg.png")`,backgroundRepeat: `round`,backgroundPosition: `center right`}:{  backgroundImage: `url("../assets/images/homeImg_ar.png")`,backgroundRepeat: `round`,backgroundPosition: `center left`};

  return (

    <section className="services-section-four pad220_0" style={sectionStyle}>
  
      <div className='auto-container'>
        <div className='row'>

       
      
         
        <div className='col-md-4'>
                                  <div className="blocks-outer">
                                                  
                                            
                                                  <div className="services-block-seven">
                                                    <div className="inner-box">
                                                      <div className="icon-box">
                                                        <span className="icon flaticon-paper"></span>
                                                      </div>
                                                      <div className="text">{t('Desc1')}</div>
                                                    </div>
                                                  </div>

                                                  <div className="services-block-seven">
                                                    <div className="inner-box">
                                                      <div className="icon-box">
                                                        <span className="icon flaticon-board"></span>
                                                      </div>
                                                      <div className="text">{t('Desc2')}</div>
                                                    </div>
                                                  </div>
                                  
                                                  <div className="services-block-seven">
                                                    <div className="inner-box">
                                                      <div className="icon-box"> 
                                                        <span className="icon flaticon-statistics"></span>
                                                      </div>
                                                      <div className="text">{t('Desc3')}</div>
                                                    </div>
                                                  </div>
                                      
                                                 
                                                  
                                  </div>

                      </div>

                      




          </div>


        </div>

    </section>
  )
  
}



export default Home  